// React
import React, { Fragment, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import { Button as ButtonContainer, HostStyles, Label, Overlay } from './styles'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird as farSpinnerThird, faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import ClientActions from 'store/v2/redux/actions/client'

const CheckoutButton = ({ disabled, t, book }) => {
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState(null)

  const handleBook = useCallback(() => {
    let timeout

    setLoading(true)

    book()
      .catch(() => {
        setStatus('error')
      })
      .finally(() => {
        setLoading(false)
        timeout = setTimeout(() => {
          setStatus(null)
        }, 3000)
      })

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Fragment>
      <HostStyles />
      <ButtonContainer
        onClick={loading || disabled ? undefined : handleBook}
        disabled={disabled}
        loading={loading ? true : undefined}
        status={status}
        className="bq-button"
      >
        <Label>{t('user.store.checkout')}</Label>
        {loading && (
          <Overlay>
            <FontAwesomeIcon className="loading" icon={farSpinnerThird} size="sm" />
          </Overlay>
        )}
        {status === 'error' && (
          <Overlay>
            <FontAwesomeIcon icon={farTimes} size="sm" />
          </Overlay>
        )}
      </ButtonContainer>
    </Fragment>
  )
}

CheckoutButton.displayName = 'Button'

CheckoutButton.propTypes = {
  disabled: PropTypes.bool,
  book: PropTypes.func,
  t: PropTypes.func
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    book: () => {
      return new Promise((resolve, reject) => {
        if (ClientActions.evaluateCartOverdue()) {
          reject(new Error('Cart is overdue'))
        } else {
          ClientActions.setCheckingOut()

          resolve()
        }
      })
    }
  }
}

export default compose(withTranslation('user'), reduxConnect(null, mapDispatchToProps))(CheckoutButton)
